// extracted by mini-css-extract-plugin
export var legendIndicator = "_en-1";
export var legendRight = "_en-0";